import { createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderSlot as _renderSlot, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = {
  key: 0,
  class: "loading-icon"
}
const _hoisted_3 = {
  key: 1,
  class: "chevron"
}
const _hoisted_4 = { class: "text" }
const _hoisted_5 = { class: "wrapper" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Icon = _resolveComponent("Icon")
  const _component_Collapse = _resolveComponent("Collapse")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["collapse-menu", {open: $data.open}])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["title", {loading: $props.loading, pointer: !$props.loading}]),
      onClick: _cache[0] || (_cache[0] = $event => (!$props.loading && $options.openMenu()))
    }, [
      _createElementVNode("span", {
        class: "ellipsis",
        innerHTML: $props.title
      }, null, 8 /* PROPS */, _hoisted_1),
      ($props.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createCommentVNode(" Loading... "),
            _cache[1] || (_cache[1] = _createTextVNode(" Generating... ")),
            _createVNode(_component_Icon, {
              icon: "animated/logo-line-v2-90f",
              width: "1.6rem",
              height: "1.6rem",
              external: ""
            })
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, _toDisplayString($data.open ? 'Collapse' : 'Expand'), 1 /* TEXT */),
            _createVNode(_component_Icon, {
              class: "icon",
              icon: "chevron-down",
              width: "1.6rem",
              height: "1.6rem"
            })
          ]))
    ], 2 /* CLASS */),
    (!$props.loading)
      ? (_openBlock(), _createBlock(_component_Collapse, {
          key: 0,
          open: $data.open,
          class: "collapse"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              _renderSlot(_ctx.$slots, "default", {}, undefined, true)
            ])
          ]),
          _: 3 /* FORWARDED */
        }, 8 /* PROPS */, ["open"]))
      : _createCommentVNode("v-if", true)
  ], 2 /* CLASS */))
}